import { formatAmount } from '../../shared/utils/misc';

export const WORK_AGE = {
  NEW: 'NEW',
  EXISTING: 'EXISTING',
};

export const WORK_AGE_OPTIONS = [
  { label: 'New Work', value: WORK_AGE.NEW },
  { label: 'Existing Work', value: WORK_AGE.EXISTING },
];

export const WORK_AGE_LABELS = {
  NEW: 'New Job',
  EXISTING: 'Existing Job',
};

export const WORK_CATEGORY = {
  ALLIED: 'ALLIED',
  BUILDING: 'BUILDING',
  ALLIED_BUILDING: 'ALLIED_BUILDING',
};

export const WORK_CATEGORY_LABELS = {
  ALLIED: 'Allied Work',
  BUILDING: 'Building Work',
  ALLIED_BUILDING: 'Allied + Building Work',
};

export const WORK_CATEGORY_OPTIONS = [
  { label: 'Allied Work', value: WORK_CATEGORY.ALLIED },
  { label: 'Building Work', value: WORK_CATEGORY.BUILDING },
  { label: 'Allied + Building Work', value: WORK_CATEGORY.ALLIED_BUILDING },
];

export const BUILDING_TYPE_OPTIONS = [
  { label: 'Residential Building', value: 'RESIDENTIAL' },
  { label: 'Commercial Building', value: 'COMMERCIAL' },
  {
    label: 'Residential & Commercial Building',
    value: 'RESIDENTIAL_COMMERCIAL',
  },
  { label: 'Industrial Building', value: 'INDUSTRIAL' },
  { label: 'Factory Shed', value: 'FACTORY_SHED' },
  { label: 'Institutional/School Building', value: 'INSTITUTIONAL' },
  { label: 'Hospital Building', value: 'HOSPITAL' },
  { label: 'Mangal Karyalay', value: 'MANGAL_KARYALAY' },
  { label: 'Bungalow', value: 'BUNGALOW' },
  { label: 'Row House', value: 'ROW_HOUSE' },
  { label: 'Farm House', value: 'FARM_HOUSE' },
  { label: 'Club House', value: 'CLUB_HOUSE' },
  { label: 'Retaining Wall', value: 'RETAINING_WALL' },
  { label: 'Compound Wall', value: 'COMPOUND_WALL' },
  { label: 'Swimming Tank', value: 'SWIMMING_TANK' },
  { label: 'Entrance Gate', value: 'ENTRANCE_GATE' },
  { label: 'Hotel Building', value: 'HOTEL' },
  { label: 'Restaurant Building', value: 'RESTAURANT' },
  { label: 'Road & Culverts', value: 'ROAD_CULVERTS' },
  { label: 'Others', value: 'OTHERS' },
];

export const BUILDING_TYPE_OTHER_OPTIONS = [{ label: 'Others', value: 'OTHERS' }];

export const GROUND_LEVEL_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
};

export const GROUND_LEVEL_TYPE_OPTIONS = [
  { label: 'Single', value: GROUND_LEVEL_TYPE.SINGLE },
  { label: 'Multiple', value: GROUND_LEVEL_TYPE.MULTIPLE },
];

export const GROUND_LEVEL_USAGE = {
  PARKING: 'PARKING',
  GROUND: 'GROUND',
};

export const GROUND_LEVEL_USAGE_OPTIONS = [
  { label: 'Parking', value: GROUND_LEVEL_USAGE.PARKING },
  { label: 'Ground floor', value: GROUND_LEVEL_USAGE.GROUND },
];

export const UPPER_FLOOR_CATEGORIES = {
  OFFICE: 'OFFICE',
  PARKING: 'PARKING',
  AMENITIES: 'AMENITIES',
  OTHER: 'OTHER',
};

export const UPPER_FLOOR_CATEGORY_OPTIONS = [
  { key: UPPER_FLOOR_CATEGORIES.OFFICE, label: 'Office space' },
  { key: UPPER_FLOOR_CATEGORIES.PARKING, label: 'Parking' },
  { key: UPPER_FLOOR_CATEGORIES.AMENITIES, label: 'Amenities / Recreation' },
  { key: UPPER_FLOOR_CATEGORIES.OTHER, label: 'Rest of the building' },
];

export const SANCTIONING_AUTHORITY_TYPE = {
  PMC: 'PMC',
  PCMC: 'PCMC',
  PMRDA: 'PMRDA',
  TOWN_PLANNING: 'TOWN_PLANNING',
  MUNICIPAL: 'MUNICIPAL',
  OTHER: 'OTHER',
};

export const MUNICIPAL_COUNCIL = {
  AMBEGAON: 'AMBEGAON',
  BARAMATI: 'BARAMATI',
  BHOR: 'BHOR',
  DAUND: 'DAUND',
  HAVELI: 'HAVELI',
  INDAPUR: 'INDAPUR',
  JUNNAR: 'JUNNAR',
  KHED: 'KHED',
  MAVAL: 'MAVAL',
  MULSHI: 'MULSHI',
  PUNE_CITY: 'PUNE_CITY',
  PURANDAR: 'PURANDAR',
  SHIRUR: 'SHIRUR',
  VELHE: 'VELHE',
  OTHER: 'OTHER',
};

export const SANCTIONING_AUTHORITY_BASIC_OPTIONS = [
  { label: 'PMC', value: 'PMC' },
  { label: 'PCMC', value: 'PCMC' },
  { label: 'PMRDA', value: 'PMRDA' },
];

export const SANCTIONING_AUTHORITY_TOWN_PLANNING_OPTION = [
  { label: 'Town Planning', value: SANCTIONING_AUTHORITY_TYPE.TOWN_PLANNING },
];

export const SANCTIONING_AUTHORITY_OPTIONS = [
  { label: 'PMC', value: SANCTIONING_AUTHORITY_TYPE.PMC },
  { label: 'PCMC', value: SANCTIONING_AUTHORITY_TYPE.PCMC },
  { label: 'PMRDA', value: SANCTIONING_AUTHORITY_TYPE.PMRDA },
  { label: 'Town Planning', value: SANCTIONING_AUTHORITY_TYPE.TOWN_PLANNING },
  { label: 'Municipal Council', value: SANCTIONING_AUTHORITY_TYPE.MUNICIPAL },
];

export const MUNICIPAL_COUNCIL_OPTIONS = [
  { label: 'Ambegaon', value: MUNICIPAL_COUNCIL.AMBEGAON },
  { label: 'Baramati', value: MUNICIPAL_COUNCIL.BARAMATI },
  { label: 'Bhor', value: MUNICIPAL_COUNCIL.BHOR },
  { label: 'Daund', value: MUNICIPAL_COUNCIL.DAUND },
  { label: 'Haveli', value: MUNICIPAL_COUNCIL.HAVELI },
  { label: 'Indapur', value: MUNICIPAL_COUNCIL.INDAPUR },
  { label: 'Junnar', value: MUNICIPAL_COUNCIL.JUNNAR },
  { label: 'Khed', value: MUNICIPAL_COUNCIL.KHED },
  { label: 'Maval', value: MUNICIPAL_COUNCIL.MAVAL },
  { label: 'Mulshi', value: MUNICIPAL_COUNCIL.MULSHI },
  { label: 'Pune City', value: MUNICIPAL_COUNCIL.PUNE_CITY },
  { label: 'Purandar', value: MUNICIPAL_COUNCIL.PURANDAR }, // fixed typo
  { label: 'Shirur', value: MUNICIPAL_COUNCIL.SHIRUR },
  { label: 'Velhe', value: MUNICIPAL_COUNCIL.VELHE },
  // { label: 'Other', value: MUNICIPAL_COUNCIL.OTHER },
];

export const MAX_PAYMENT_MILESTONES = 10;

export const PAYMENT_MILESTONE_COUNT_OPTIONS = Array.from(
  { length: MAX_PAYMENT_MILESTONES },
  (_, i) => {
    const value = i + 1;
    return { label: String(value), value };
  },
);

/**
 * The firm's standard payment stages, and the split they are normally quoted at.
 *
 * These are the four stages every letter in `PDF/` uses, so a four-milestone quotation
 * opens on them already filled in rather than on four blank rows. They stay editable —
 * this is a starting point, not a fixed schedule.
 *
 * `QuotationPdfService.DEFAULT_MILESTONES` carries the same wording as the fallback for
 * milestones saved before this seeded them; the two must stay in step.
 */
export const DEFAULT_MILESTONES = [
  { index: 1, percentage: 10, label: 'Advance.' },
  {
    index: 2,
    percentage: 40,
    label: 'At the time of delivery of set of Preliminary Drawings for Estimation.',
  },
  { index: 3, percentage: 40, label: 'At the time of delivery of set of Final Drawings.' },
  { index: 4, percentage: 10, label: 'At the time of delivering completion of work.' },
];

/** How many milestones {@link DEFAULT_MILESTONES} covers. */
export const DEFAULT_MILESTONE_COUNT = DEFAULT_MILESTONES.length;

export const QUOTE_AS_PER = {
  SQFT: 'SQFT',
  PERCENTAGE: 'PERCENTAGE',
  LUMPSUM: 'LUMPSUM',
};

export const QUOTE_AS_PER_OPTIONS = [
  { label: 'Sq. ft.', value: QUOTE_AS_PER.SQFT },
  { label: 'Percentage', value: QUOTE_AS_PER.PERCENTAGE },
  { label: 'Lump-sum', value: QUOTE_AS_PER.LUMPSUM },
];

export const QUOTE_AS_PER_LABELS = {
  SQFT: 'Sq. ft.',
  PERCENTAGE: 'Percent',
  LUMPSUM: 'Lumpsum',
};

export const FINAL_AMOUNT_SOURCE = {
  CALCULATED: 'CALCULATED',
  MANUAL: 'MANUAL',
};

/** The least fee a sq.ft. or percentage quotation can go ahead with ("Proceed with Minimum"). */
export const MINIMUM_FEE = 25000;

export const MINIMUM_AMOUNT = formatAmount(MINIMUM_FEE);

export const FINAL_AMOUNT_SOURCE_OPTIONS = [
  { label: 'Proceed with Actual', value: FINAL_AMOUNT_SOURCE.CALCULATED },
  {
    label: `Proceed with Minimum (${MINIMUM_AMOUNT})`,
    value: FINAL_AMOUNT_SOURCE.MANUAL,
  },
];

export const COMPANY_NAMES = {
  SDLLP: 'SDLLP',
  SCPL: 'SCPL',
};

export const COMPANY_NAME_LABELS = {
  SDLLP: 'Structualtants Design LLP',
  SCPL: 'Shirke Consultants Pvt. Ltd.',
};

export const COMPANY_NAME_OPTIONS = [
  { label: 'Structualtants Design LLP', value: COMPANY_NAMES.SDLLP },
  { label: 'Shirke Consultants Pvt. Ltd.', value: COMPANY_NAMES.SCPL },
];

export const OWNER_NAMES = {
  R_V_SHIRKE: 'R_V_SHIRKE',
  S_S_DESARDA: 'S_S_DESARDA',
};

export const SIGNATURE_OPTIONS = [
  { label: 'R. V. Shirke', value: OWNER_NAMES.R_V_SHIRKE },
  { label: 'S. S. Desarda', value: OWNER_NAMES.S_S_DESARDA },
];
